import { render } from "./Icons.vue?vue&type=template&id=303fe98c&ts=true"
import script from "./Icons.vue?vue&type=script&lang=ts"
export * from "./Icons.vue?vue&type=script&lang=ts"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__